import { Component } from '@angular/core';

@Component({
    selector: 'app-notificacao',
    templateUrl: './notificacao.component.html',
    styleUrl: './notificacao.component.css',
    standalone: false
})
export class NotificacaoComponent {

}
